import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackClick } from './tracking';
import { EAlertType, chatAuthSucceed, requestAuthentication } from '../../actions/authentication';
import { openChatModal } from '../../actions/chatModal';
import { selectIsChatEnabled } from '../../selectors/chat';
import { selectIsAuthenticated } from '../../selectors/user';
import { TThunkDispatch } from '../../types/redux';
import { TRecommendation } from '../../types/recommendation';

type TOpenChatParams = { defaultMessage?: string; customTrackClick?: () => void };

export function useChats(offer: TRecommendation | null) {
  const isChatsEnabled = selectIsChatEnabled(offer);
  const isUserAuthenticated = useSelector(selectIsAuthenticated);

  const dispatch = useDispatch<TThunkDispatch>();

  const handleOpenChat = useCallback(
    (params: TOpenChatParams | void) => {
      const { defaultMessage, customTrackClick } = params || {};

      if (!offer) {
        return;
      }

      const { gaLabel, offerId } = offer;

      if (customTrackClick) {
        customTrackClick();
      } else {
        trackClick(gaLabel);
      }
      if (isUserAuthenticated) {
        dispatch(openChatModal({ offerId, gaLabel, defaultMessage }));
      } else {
        dispatch(requestAuthentication({ alert: EAlertType.Chats, onSuccess: chatAuthSucceed({ offerId, gaLabel }) }));
      }
    },
    [dispatch, isUserAuthenticated, offer],
  );

  return useMemo(
    () => ({
      isEnabled: isChatsEnabled,
      openChat: handleOpenChat,
    }),
    [isChatsEnabled, handleOpenChat],
  );
}
